// Copyright ©️ 2025 eVolve MEP, LLC

import { useEffect } from 'react';

import { useBlocker } from './useBlocker';

export const useBlockerWhen = <T extends string>(name: T, when: boolean) => {
  const [block, unblock, registerMessage] = useBlocker<T>(name);
  useEffect(() => {
    if (when) {
      return block();
    }
    return undefined;
  }, [block, when]);
  return { block, unblock, registerMessage };
};
